import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import StatusEnum from '@/components/StatusEnum'

export default ({ enumName, visualStatus }) => {
  return class EnumCellStatus extends GridCell {
    render () {
      const value = this.props.dataItem[this.props.field]
      return (<td className='td-status'>
        <StatusEnum value={value} enumName={enumName} visualStatus={visualStatus} />
      </td>)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/BsrsGrid.EnumCellStatus.js